import { atomWithStorage } from 'jotai/utils';

interface IIngestionConfig {
    collapse_last_arg_updated?: boolean;
}

interface IConsumptionChannelConfig {
    name: string;
    queue_name: string;
    queue_url: string;
    sns_topic: string;
}

export interface IConsumptionChannel extends IConsumptionChannelConfig {
    uiId: string;
    name: string;
    organization: IOrganization;
}

interface IConversationConfig {
    enabled: boolean;
    global_guidelines_prompt_name?: string;
    client_guidelines_prompt_name?: string;
    output_validation_prompt_name?: string;
}

export interface IOrganizationConfig {
    demo: boolean;
    agent?: {
        id: string;
    };
    chat?: {
        enabled: boolean;
    };
    conversation?: IConversationConfig;
    ingestion?: IIngestionConfig;
    ticket_merging?: {
        allow: boolean;
    };
    consumption?: {
        channels: IConsumptionChannelConfig[];
    };
    bot_author_id?: string; // Deprecated: use bot_author_ids instead
    bot_author_ids?: string[];
    response_markup_language: 'HTML' | 'MARKDOWN';
}

export interface IOrganization {
    id: number;
    name: string;
    org_policy_set_id: number;
    disabled: boolean;
    is_live_client: boolean;
    config: IOrganizationConfig;
    is_active: boolean;
    client_name: string;
}

export interface IOrganizationCreate {
    name: string;
    desired_id?: number;
    client_name?: string;
}

export interface IOrganizationUpdate {
    id: number;
    config?: IOrganizationConfig;
}

export const selectedChannelsAtom = atomWithStorage<IConsumptionChannel[]>('tymely-selected-channels', []);
